import { createTheme } from "@mui/material/styles";
import { defaultTheme } from "components/Theme/Style";

const theme = createTheme(defaultTheme, {
  palette: {
    mode: "light",
    primary: { main: "#7FC9BD", dark: "#7FC9BD" },
    secondary: { main: "#222423" },
    neutral: { main: "#5c6ac4" },
  },
});

export default theme;
